/**
 * SeaCloud SDK 核心模块
 */

import { getClient as getClientInternal } from './global-config.js';
import type { TaskResult } from './types.js';

// 全局初始化和配置管理
export {
  initSeacloud,
  getClient,
  getDefaultPollingOptions,
  setDefaultPollingOptions,
  setCustomHeaders,
  getCustomHeaders,
  clearCustomHeaders,
  resetConfig,
} from './global-config.js';
export type { InitOptions } from './global-config.js';

// 内部使用的模块（用户一般不需要直接使用）
export { SeacloudClient } from './client.js';
export {
  createConfig,
  validateConfig,
  getHostFromParent,
  notifyParentNeedRecharge,
  checkAndNotifyInsufficientBalance,
  checkResponseBodyForInsufficientBalance,
  checkStreamChunkForInsufficientBalance,
} from './config.js';
export { pollTaskUntilComplete, createAndWaitTask } from './poller.js';

// 类型导出
export type {
  SeacloudConfig,
  TaskStatus,
  TaskError,
  TaskResult,
  PollingOptions,
} from './types.js';
export { SeacloudError } from './types.js';

/**
 * 查询任务状态
 *
 * 用于查询已创建任务的当前状态和结果。
 *
 * @example
 * ```typescript
 * import { initSeacloud, getTaskStatus } from 'seacloud-sdk';
 *
 * initSeacloud('your-api-key');
 *
 * const result = await getTaskStatus('/model/v1/generation', 'task-123');
 * console.log(result.status); // 'pending' | 'processing' | 'completed' | 'failed'
 * if (result.status === 'completed') {
 *   console.log(result.output); // 任务输出结果
 * }
 * ```
 *
 * @param endpoint API 端点路径（例如：/model/v1/generation）
 * @param taskId 任务 ID
 * @returns 任务结果，包含状态、输出等信息
 */
export async function getTaskStatus(endpoint: string, taskId: string): Promise<TaskResult> {
  const client = await getClientInternal();
  return client.getTaskStatus(endpoint, taskId);
}
